export default function takeScreenshot(options = { hidePrompt: false }) {
  let startX;
  let startY;
  let box;
  // const iframeWrapper = document.getElementById('one-click-to-notion');
  const iframeElement = document.getElementById('my-iframe');

  const hide = () => {
    // iframeWrapper.style.display = 'block';

    document.body.style.setProperty('user-select', 'unset');
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('mousedown', handleMousedown);
    window.removeEventListener('keydown', handleKeyDown);
  };

  function cropImage(src, dimensions) {
    const img = new Image();
    img.src = src;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    return new Promise((resolve, reject) => {
      img.onload = () => {
        const scaleFactor = img.width / window.innerWidth;
        canvas.width = dimensions.width * scaleFactor;
        canvas.height = dimensions.height * scaleFactor;

        ctx.drawImage(img, dimensions.x * scaleFactor, dimensions.y * scaleFactor, dimensions.width * scaleFactor, dimensions.height * scaleFactor, 0, 0, dimensions.width * scaleFactor, dimensions.height * scaleFactor);
        resolve(canvas.toDataURL());
      };
      img.onerror = reject;
    });
  }

  const createCanvas = (dimensions) => {
    browser.runtime.sendMessage({ takeScreenshot: true }).then((imageUrl) => {
      cropImage(imageUrl, dimensions).then((data) => {
        // iframeElement.contentWindow.postMessage({ msg: 'NOTIX_ADD_SCREENSHOT', src: encodeURI(data) }, '*');
        browser.runtime.sendMessage({ msg: 'NOTIX_ADD_SCREENSHOT', src: encodeURI(data) });
        hide();
      });
    });
  };

  const visibleAreaScreenshot = () => {
    tooltip.remove();
    createCanvas({ x: 0, y: 0, width: window.innerWidth, height: window.innerHeight });
  };

  if (options.hidePrompt) {
    // iframeWrapper.style.display = 'none';
    browser.runtime.sendMessage({ takeScreenshot: true }).then((imageUrl) => {
      cropImage(imageUrl, { x: 0, y: 0, width: window.innerWidth, height: window.innerHeight }).then((data) => {
        // iframeWrapper.style.display = 'block';
        browser.runtime.sendMessage({ msg: 'NOTIX_ADD_SCREENSHOT', src: encodeURI(data) });
        // iframeElement.contentWindow.postMessage({ msg: 'NOTIX_ADD_SCREENSHOT', src: encodeURI(data) }, '*');
      });
    });
    return;
  }

  const hintElement = `
<div id="notix-overlay" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 99999; cursor: crosshair">
  <div id="notix-hint" style="position: fixed; transform: translate(-50%, 0); bottom: 4rem; left: 50%; padding: 1.2rem; background: black; color: rgb(189, 189, 189); border-radius: 0.4rem; font-family: -apple-system, BlinkMacSystemFont, Segoe UI, SF Pro Display, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;">
    <div><span style="color: white;">Click and drag</span> to select an area</div>
    <div> Press <span style="color: white;">Space</span> for visible area</div>
    <div style="display: flex; margin-top: 1rem;">
      <div style="margin-left: auto;">
        <button
            id="cancel-button"
            style="border: 1px solid white; cursor: pointer; padding: 0.4rem 0.8rem; border-radius: 0.4rem; font-size: 14px; color: white; background: transparent;"
        > Cancel
        </button>
      </div>
    </div>
  </div>
</div>
`;

  const template = document.createElement('template');
  template.innerHTML = hintElement.trim();
  const tooltip = template.content.childNodes[0];
  document.body.appendChild(tooltip);

  const handleMousedown = (event) => {
    startX = event.clientX;
    startY = event.clientY;

    document.getElementById('notix-hint').remove();

    box = document.createElement('div');
    box.style = `
    background: rgba(35, 131, 226, 0.28);
      position: fixed;
      left: ${startX}px;
      top: ${startY}px;
      height: 10px;
      width: 10px;
      z-index: 9999;
    `;
    document.body.appendChild(box);

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  const handleMouseMove = (event) => {
    const height = Math.abs(startY - event.clientY);
    const width = Math.abs(startX - event.clientX);
    if (startY >= event.clientY) {
      box.style.top = `${startY - height}px`;
    }
    if (startY < event.clientY) {
      box.style.top = `${startY}px`;
    }
    if (startX >= event.clientX) {
      box.style.left = `${startX - width}px`;
    }
    if (startX < event.clientX) {
      box.style.left = `${startX}px`;
    }
    box.style.height = `${height}px`;
    box.style.width = `${width}px`;
  };

  const handleMouseUp = () => {
    tooltip.remove();
    box.style.background = 'transparent';
    const dimensions = box.getBoundingClientRect();
    if (box !== undefined) {
      box.remove();
      setTimeout(() => {
        createCanvas(dimensions);
      }, 20);
      return;
    }
    createCanvas(dimensions);
  };

  const handleCancelClick = (event) => {
    tooltip.remove();
    event.stopPropagation();
    hide();
  };

  const handleKeyDown = (event) => {
    if (event.code === 'Space') {
      event.preventDefault();
      visibleAreaScreenshot();
    }
  };

  const cancelButton = document.getElementById('cancel-button');
  cancelButton.addEventListener('click', handleCancelClick);
  cancelButton.addEventListener('mousedown', (event) => event.stopPropagation());
  cancelButton.addEventListener('mouseup', (event) => {
    event.stopPropagation();
  });

  document.body.style.setProperty('user-select', 'none');
  // iframeWrapper.style.display = 'none';
  document.addEventListener('mousedown', handleMousedown);
  window.addEventListener('keydown', handleKeyDown);
  window.focus();
}
